<template>
    <!-- <div class="content-map-geloation" v-show="showMap"> -->
        <GmapMap
            v-if="showMap"     
            :center="center"
            :zoom="15"
            :options="themeDark == true ? mapStyle : null"
            :style="`width:${+widthPercent}%; height: ${+heightPixel}px;`"
            class="map-page-contact"
        >
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="clickMarker"
            />
        </GmapMap>
    <!-- </div> -->
</template>

<script>
export default {
    name: "GoogleMap",
    props: {
        widthPercent: {
            required: true,
            type: Number | String
        },
        heightPixel: {
            required: true,
            type: Number | String
        },
        lat: {
            type: Number | String,
            required: true
        },
        lng: {
            type: Number | String,
            required: true
        },
        marks: {
            default: Array
        },
        themeDark: {
            default: false
        },
        loading_lazy: {
            default: false
        }
    },
    data() {
        return {
            theme_dark: this.$root.$children[0].theme?.maps?.active_theme_dark ?? false,
            center: {},
            currentPlace: null,
            places: [],
            markers:[],
            mapStyle: {
                styles: [
                    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                    { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }], },
                    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }], },
                    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }], },
                    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }], },
                    { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }], },
                    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }], },
                    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }], },
                    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }], },
                    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }], },
                    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }], },
                    { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }], },
                    { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }], },
                    { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }], },
                    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }], },
                    { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }], }
                ]
            },
            showMap: false
        };
    },
    mounted() {
        if(this.loading_lazy) {
            let self = this
            window.addEventListener('scroll', () => {
                if (!document.querySelectorAll('.footer').length) {
                    return;
                }
                let rect = document.querySelectorAll('.footer')[0].getBoundingClientRect().top
                self.showMap = (+rect + +window.scrollY) < (+window.innerHeight + +window.scrollY + 60)
            })
        } else {
            this.showMap = true
        }

        this.center = {
            lat: Number(this.lat),
            lng: Number(this.lng)
        }
        if(!this.marks.length){
           return this.addMarker(this.center);
        }
        this.marks.map(el => this.addMarker(el));
    },
    methods: {
        addMarker(coords) {
            const marker = coords;
            this.markers.push({ position: marker });
            this.places.push(this.currentPlace);
            this.currentPlace = null;
        },
        clickMarker(val) {
            let lat = val.latLng.lat()
            let lng = val.latLng.lng()
            window.open(`http://maps.google.com/maps?daddr=${lat},${lng}&amp;ll=`)
        }
    }
};
</script>

<style scoped>
@media (max-width: 991px) {
    .map-page-contact {
        width: 100% !important;
    }
}
</style>